"use client";

import { Lock, ShieldCheck, Headphones } from "@/components/icons";

export function TrustRow({ commitmentLabel = "No commitments" }: { commitmentLabel?: string }) {
  return (
    <div className="text-muted-foreground flex flex-wrap items-center justify-center gap-4 pt-4 text-xs">
      {[
        { icon: Lock, label: "SSL secured" },
        { icon: ShieldCheck, label: commitmentLabel },
        { icon: Headphones, label: "Premium support" },
      ].map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-1.5">
          <Icon size={13} aria-hidden="true" />
          {label}
        </div>
      ))}
    </div>
  );
}
